import React from 'react';
import { Tag, Tooltip, Typography } from 'antd';
import { DEFAULT_FAULT, SEVERITY_COLORS, faultHolder } from './issueFields';
import type {
	Program,
	ProgramIssue,
} from '../../interfaces/CamProgramming.interface';

const { Text } = Typography;

interface IssueContentMetaProps {
	issue: ProgramIssue;
	/** Names the person at fault; without it the role label is shown instead. */
	program?: Program;
}

/** Chips above an issue's description in the read-only viewer. */
const IssueContentMeta: React.FC<IssueContentMetaProps> = ({
	issue,
	program,
}) => {
	const holder = faultHolder(program, issue);
	const faultName = holder?.full_name || holder?.email || issue.fault_display;
	const redirected = issue.fault !== DEFAULT_FAULT;

	return (
		<>
			<Tag color={SEVERITY_COLORS[issue.severity]} bordered={false}>
				{issue.severity_display}
			</Tag>
			<Text type="secondary" className="cam-entry__chip">
				Caught in {issue.caught_phase_display}
			</Text>
			<Text type="secondary" className="cam-entry__chip">
				At fault: {faultName}
			</Text>
			{redirected && (
				<Tooltip
					title={`Charged to the ${issue.fault_display.toLowerCase()} instead of the programmer.`}
				>
					<Tag color="purple" bordered={false}>
						{issue.fault_display}
					</Tag>
				</Tooltip>
			)}
			{issue.insufficient_training && (
				<Tooltip title="Logged as a training gap, so it is not charged against them.">
					<Tag color="blue" bordered={false}>
						Training
					</Tag>
				</Tooltip>
			)}
		</>
	);
};

export default IssueContentMeta;
